<template>
  <div>
    <wc-data-box
      v-if='estimate.estimate_detail'
      title='Lot Size Category'
      :titleIcon='icon'
      :titleIconColor='iconColor'
      :showEdit='!estimate.is_sold'
      @edit='changeRating'
      :loading='isLoading'
    >
      <v-card-text class='text-center'>
        <h1 v-if='ratingDisplay.description.length' class='display-1 font-weight-light info--text'>{{ ratingDisplay.rating | dec }}</h1>
        <h1 v-else class='display-1 font-weight-light info--text'>Not Set</h1>
        <h2 class='mt-2'>{{ ratingDisplay.description }}</h2>
      </v-card-text>
      <wc-ratings :selected='estimate.estimate_detail.rating' :ratings='ratings'></wc-ratings>
    </wc-data-box>
    <wc-dialog
      :showDialog='showDialog'
      title='Change Rating'
      :icon='icon'
      :iconColor='iconColor'
      width='300'
      @cancel='showDialog = false'
      @save='updateRating'
    >
      <v-select
        v-model='estimateDetailCopy.rating'
        label='Select a rating'
        :items='ratings'
        :item-text='getSelectionText'
        item-value='id'
      ></v-select>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import settingsAPI from '@/modules/settings/api/settings'

export default {
  name: 'lawn-estimate-lot-rating',
  props: {
    estimate: {
      required: true
    },
  },
  data: () => ({
    isLoading: true,
    showDialog: false,
    estimateDetailCopy: [],
    ratings: [],
    icon: 'mdi-home-outline',
    iconColor: 'brown'
  }),
  created () {
    this.getData()
  },
  computed: {
    ratingDisplay () {
      if (this.estimate.estimate_detail.rating && this.ratings.length) {
        return _.find(this.ratings, r => r.id === this.estimate.estimate_detail.rating)
      }
      return { rating: null, description: '' }
    }
  },
  methods: {
    changeRating () {
      this.estimateDetailCopy = _.cloneDeep(this.estimate.estimate_detail)
      this.showDialog = true
    },
    async getData () {
      this.isLoading = true
      this.ratings = await settingsAPI.getRatings()
      this.isLoading = false
    },
    async updateRating () {
      this.$emit('updateDetail', this.estimateDetailCopy)
      this.showDialog = false
    },
    getSelectionText(item) {
      return item.description + ' - ' + this.$options.filters.decMoney(item.base_price)
    }
  }
}
</script>